var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavedBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/archive-tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.041 4.16675H14.9577C10.5202 4.16675 6.91602 7.79175 6.91602 12.2084V41.5626C6.91602 45.3126 9.60352 46.8959 12.8952 45.0834L23.0618 39.4376C24.1452 38.8334 25.8952 38.8334 26.9577 39.4376L37.1244 45.0834C40.416 46.9167 43.1035 45.3334 43.1035 41.5626V12.2084C43.0827 7.79175 39.4785 4.16675 35.041 4.16675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9577 2.29175C9.48149 2.29175 5.04102 6.75938 5.04102 12.2084V41.5626C5.04102 43.8519 5.87747 45.9396 7.71971 47.0246C9.56051 48.1087 11.7931 47.8307 13.7996 46.7259L13.8055 46.7226L23.9751 41.0751C24.1711 40.9658 24.5457 40.8595 25.0176 40.8595C25.4913 40.8595 25.8532 40.9666 26.0308 41.0676L36.212 46.7215C38.2167 47.838 40.4533 48.1277 42.2998 47.0402C44.1453 45.9533 44.9785 43.8573 44.9785 41.5626L44.9785 12.2084L44.9785 12.1996C44.9528 6.75916 40.5189 2.29175 35.041 2.29175H14.9577ZM14.9577 6.04175C11.5589 6.04175 8.79102 8.82412 8.79102 12.2084V41.5626C8.79102 43.0233 9.29832 43.6022 9.62274 43.7933C9.94836 43.9851 10.7045 44.1483 11.9879 43.4426C11.9888 43.442 11.9898 43.4415 11.9908 43.4409L22.1486 37.8C23.0357 37.3055 24.0783 37.1095 25.0176 37.1095C25.952 37.1095 26.9924 37.3032 27.8752 37.8024L38.0346 43.4442C39.3216 44.161 40.0766 43.9975 40.3968 43.8089C40.718 43.6198 41.2285 43.0387 41.2285 41.5626V12.213C41.2102 8.82202 38.4367 6.04175 35.041 6.04175H14.9577Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.916 22.1875C17.916 21.152 18.7555 20.3125 19.791 20.3125H30.2077C31.2432 20.3125 32.0827 21.152 32.0827 22.1875C32.0827 23.223 31.2432 24.0625 30.2077 24.0625H19.791C18.7555 24.0625 17.916 23.223 17.916 22.1875Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 15.2292C26.0355 15.2292 26.875 16.0687 26.875 17.1042V27.5209C26.875 28.5564 26.0355 29.3959 25 29.3959C23.9645 29.3959 23.125 28.5564 23.125 27.5209V17.1042C23.125 16.0687 23.9645 15.2292 25 15.2292Z",
    fill: "#0082CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedBig);
export default __webpack_public_path__ + "static/media/saved-big.534c5b4331059f986bf9775fb76622d3.svg";
export { ForwardRef as ReactComponent };